<template>
	<div id="outer" ref="outer" @click="$emit('click')" :style="card_style">
		<CardRenderer id="card" :style="card_translate" :type="type"/>
	</div>
</template>

<style scoped>
@keyframes slide-up {
	0% {
		transform: translate(0, 150%);
	}
	30%, 70% {
		transform: translate(0, -70%);
	}
	100% {
		transform: translate(0, 0);
	}
}

#outer {
	animation: slide-up 1.0s ease;
	transition: 0.3s;
	pointer-events: none;
}

#outer:hover #card {
	bottom: var(--card_translate);
}
#card:hover {
	bottom: var(--card_translate);
}

#card {
	width: 100%;
	height: 100%;
	bottom: 0;
	transition: 0.3s;
	position: absolute;
}

.img {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
}

.colorable {
	fill: var(--card_color)
}
</style>

<script lang="ts">
import Vue from "vue";

import CardRenderer from "./CardRenderer.vue";

export default Vue.extend({
	components: {
		CardRenderer
	},
	data() {
		return {
			window_width: window.innerWidth
		}
	},
	mounted() {
		window.addEventListener('resize', () => {
			this.window_width = window.innerWidth;
		});
		setTimeout(
			() => this.$refs.outer.style.pointerEvents = "visiblePainted",
			300
		);
	},
	props: {
		type: Object,
		index: Number,
		playing: Boolean,
		playable: Boolean,
		num_cards: Number
	},
	computed: {
		card_height() {
			if (this.$store.state.mobile) {
				return 100;
			}
			return 150;
		},
		size_scale() {
			return this.playing ? 1.0 : 0.7;
		},
		card_translate() {
			return { "--card_translate": this.playing ? "26%" : "0" };
		},
		card_style() {
			let card_size_width_ratio = 0.63;
			let window_width = Math.max(this.window_width, 320);
			var screen_max = (window_width - (this.$store.state.mobile ? 10 : 300)) / window_width;
			screen_max = screen_max == 0 ? 1 : screen_max;
			let s =
				this.card_height *
				card_size_width_ratio *
				this.size_scale / (window_width * screen_max);
			let gap = s / 20.0;
			let n = this.num_cards;
			let width = n * s + (n - 1) * gap;
			var p = 0.0;
			if (width <= 1.0) {
				p = 0.5 - 0.5 * width + this.index * (s + gap);
			} else {
				p = (1.0 - s) * (this.index / (n - 1));
			}
			p *= screen_max;
			p += (1.0 - screen_max) / 2.0;
			var brightness = 1.0;
			if (this.playable == null) {
				brightness = this.playing ? 1.0 : 0.5;
			} else {
				brightness = this.playable ? 1.0 : 0.5;
			}
			return {
				width: this.card_height * 0.63 * this.size_scale + 'px',
				height: this.card_height * this.size_scale + 'px',
				left: p * 100 + "%",
				position: "absolute",
				filter: "brightness(" + brightness * 100 + "%)",
				cursor: "pointer",
				bottom: (10 + ((this.$store.state.mobile) ? 40 : 0)) + "px"
			}
		}
	}
})
</script>
